export default __webpack_public_path__ + "static/media/leader_notes_detailed.5ec4a4f2.pdf";